import React, {
  useMemo,
  useRef
} from "react";

import {
  FiCamera,
  FiActivity,
  FiAward,
  FiTarget,
  FiTrendingUp
} from "react-icons/fi";


const LEVELS = {

  1: "Aware",

  2: "Explorer",

  3: "Adapter",

  4: "Thriver"

};


const LEVEL_XP = {

  1: 500,

  2: 1000,

  3: 1500,

  4: 2000

};


const ProfileHero = ({

  user,

  stats,

  summary,

  achievements = [],

  onUpload

}) => {


  const inputRef =
    useRef(null);


  /* ==========================
      XP
  ========================== */

  const currentXP =
    summary?.totalXP || 0;


  const currentLevel =
    stats?.currentLevel || 1;


  const nextXP =
    LEVEL_XP[currentLevel] || 2000;


  const progress =
    Math.min(

      (
        currentXP /
        nextXP
      ) * 100,

      100

    );


  /* ==========================
      ACHIEVEMENTS
  ========================== */

  const unlockedCount =

    useMemo(

      () =>

        achievements.filter(

          item =>
            item.unlocked

        ).length,

      [achievements]

    );


  /* ==========================
      PHOTO PICKER
  ========================== */

  const openPicker = () => {

    inputRef.current?.click();

  };


  const onFileChange = async (e) => {

    const file =
      e.target.files?.[0];


    if (

      !file ||

      !onUpload

    ) {

      return;

    }


    await onUpload(file);


    /* Reset input so same
       image can be selected again */

    e.target.value = "";

  };


  /* ==========================
      STATS
  ========================== */

  const heroStats = [

    {

      icon:
        <FiActivity />,

      title:
        "Current Streak",

      value:
        stats?.currentStreak || 0,

      suffix:
        "Days"

    },

    {

      icon:
        <FiAward />,

      title:
        "Assessments",

      value:
        9

    },

    {

      icon:
        <FiTrendingUp />,

      title:
        "Total XP",

      value:
        summary?.totalXP || 0

    },

    {

      icon:
        <FiTarget />,

      title:
        "Achievements",

      value:
        `${unlockedCount}/${summary?.totalAchievements || 13}`

    }

  ];


  return (

    <section className="vp-hero">


      {/* =====================================
          LEFT MAIN HERO
      ===================================== */}

      <div className="vp-main-card">


        {/* ==============================
            PROFILE AVATAR
        ============================== */}

        <div className="vp-avatar-section">

          <div className="vp-avatar-wrapper">


            <img

              src={

                user?.profilePhoto ||

                "/Hero/profile.png"

              }

              alt="Profile"

              className="vp-avatar"

            />


            <button

              type="button"

              className="vp-camera-btn"

              onClick={openPicker}

              aria-label="Change profile photo"

            >

              +

            </button>


            <input

              type="file"

              accept="image/*"

              hidden

              ref={inputRef}

              onChange={onFileChange}

            />


          </div>

        </div>


        {/* ==============================
            PROFILE INFORMATION
        ============================== */}

        <div className="vp-info">


          {/* LEVEL BADGE */}

          <span className="vp-badge">

            LEVEL {currentLevel}

          </span>


          {/* NAME */}

          <h1>

            {user?.name || "Athlete"}

          </h1>


          {/* LEVEL NAME */}

          <h3>

            {LEVELS[currentLevel]}

          </h3>


          {/* DESCRIPTION */}

          <p>

            Every assessment brings you one
            step closer to unlocking your
            full visual potential.

          </p>


          {/* ==========================
              EXPERIENCE
          ========================== */}

          <div className="vp-progress">


            <div className="vp-progress-header">


              <span>

                Experience

              </span>


              <span>

                {currentXP}

                {" / "}

                {nextXP}

                {" XP"}

              </span>


            </div>


            <div className="vp-progress-track">


              <div

                className="vp-progress-fill"

                style={{

                  width:
                    `${progress}%`

                }}

              />


            </div>


          </div>


        </div>


      </div>


      {/* =====================================
          RIGHT SIDE STATS
      ===================================== */}

      <div className="vp-stats-grid">


        {

          heroStats.map(

            (item, index) => (

              <div

                className="vp-stat-card"

                key={index}

              >


                {/* ICON */}

                <div className="vp-stat-icon">

                  {item.icon}

                </div>


                {/* CONTENT */}

                <div className="vp-stat-content">


                  <small>

                    {item.title}

                  </small>


                  <h2>

                    {item.value}


                    {

                      item.suffix && (

                        <span>

                          {" "}

                          {item.suffix}

                        </span>

                      )

                    }


                  </h2>


                </div>


              </div>

            )

          )

        }


      </div>


    </section>

  );

};


export default ProfileHero;
